import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ThemeTypography } from 'DesignSystem';
import React from 'react';
import defaultPartnerImage from 'assets/img/partners/default-partner-image.png';
import { EAvailableSizes } from 'DesignSystem/types/size.types';
import { ICompany } from 'FeatureModules/Auth/types/company.types';

export const Logo = styled('div')<{
  backgroundImage: string;
  small: boolean;
}>(({ backgroundImage, small, theme }) => {
  const size = small ? 28 : 40;
  return {
    width: size,
    height: size,
    flexShrink: 0,
    backgroundImage: `url(${backgroundImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: 4,
  };
});

interface IProps {
  companyName: ICompany['name'];
  companyLogoUrl?: string;
  size: EAvailableSizes;
}

const CompanyNameLogo: React.FC<IProps> = ({ companyName, companyLogoUrl, size }: IProps) => {
  return (
    <Box display="inline-block">
      <Box display="flex" gap={1} alignItems="center">
        <Logo
          backgroundImage={companyLogoUrl || defaultPartnerImage}
          small={size === EAvailableSizes.SMALL || size === EAvailableSizes.MEDIUM}
        />
        <ThemeTypography
          variant={
            size === EAvailableSizes.SMALL
              ? 'BUTTON_SMALL'
              : size === EAvailableSizes.MEDIUM
              ? 'BODY_LARGE_BOLD'
              : 'TITLE_SMALL'
          }
          color={size === EAvailableSizes.SMALL ? 'BLACK' : 'GRAY_40'}
        >
          {companyName}
        </ThemeTypography>
      </Box>
    </Box>
  );
};

export default CompanyNameLogo;
